// import React, { useState, useEffect } from 'react';
// import { Table, Spinner, Alert, Badge } from 'react-bootstrap';
// import { FaFileInvoice, FaCheckCircle, FaTimesCircle, FaClock } from 'react-icons/fa';
// import { useNavigate } from 'react-router-dom';
// import './PaymentHistory.css';

// const PaymentHistory = () => {
//     const [payments, setPayments] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState('');
//     const navigate = useNavigate();

//     useEffect(() => {
//         const fetchPayments = async () => {
//             const token = localStorage.getItem('token');
//             if (!token) {
//                 navigate('/login');
//                 return;
//             }

//             try {
//                 const userResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
//                     headers: { Authorization: `Bearer ${token}` },
//                 });

//                 if (!userResponse.ok) throw new Error('Failed to fetch user data');
//                 const userData = await userResponse.json();

//                 const paymentsResponse = await fetch(
//                     `${process.env.REACT_APP_API_BASE_URL}/api/payment/user-payments/${userData.user._id}`,
//                     {
//                         headers: { Authorization: `Bearer ${token}` },
//                     }
//                 );

//                 if (!paymentsResponse.ok) throw new Error('Failed to fetch payment history');
//                 const paymentsData = await paymentsResponse.json();

//                 setPayments(paymentsData);
//             } catch (error) {
//                 setError(error.message);
//             } finally {
//                 setLoading(false);
//             }
//         };

//         fetchPayments();
//     }, [navigate]);

//     const formatDate = (dateString) => {
//         const options = {
//             year: 'numeric',
//             month: 'short',
//             day: 'numeric',
//             hour: '2-digit',
//             minute: '2-digit',
//         };
//         return new Date(dateString).toLocaleDateString(undefined, options);
//     };

//     const getStatusBadge = (status) => {
//         switch (status) {
//             case 'completed':
//                 return (
//                     <Badge bg="success" className="d-flex align-items-center">
//                         <FaCheckCircle className="me-1" /> Completed
//                     </Badge>
//                 );
//             case 'failed':
//                 return (
//                     <Badge bg="danger" className="d-flex align-items-center">
//                         <FaTimesCircle className="me-1" /> Failed
//                     </Badge>
//                 );
//             default:
//                 return (
//                     <Badge bg="warning" text="dark" className="d-flex align-items-center">
//                         <FaClock className="me-1" /> Pending
//                     </Badge>
//                 );
//         }
//     };

//     if (loading) {
//         return (
//             <div className="d-flex justify-content-center py-5">
//                 <Spinner animation="border" role="status">
//                     <span className="visually-hidden">Loading...</span>
//                 </Spinner>
//             </div>
//         );
//     }

//     if (error) {
//         return (
//             <Alert variant="danger" className="mt-4">
//                 {error}
//             </Alert>
//         );
//     }

//     return (
//         <div className="payment-history-container">
//             <div className="payment-history-header">
//                 <h2>
//                     <FaFileInvoice className="me-2" /> Payment History
//                 </h2>
//                 <p className="text-muted">View all your past transactions and payments</p>
//             </div>

//             {payments.length === 0 ? (
//                 <div className="no-payments text-center py-5">
//                     <FaFileInvoice size={48} className="text-muted mb-3" />
//                     <h5>No payment history found</h5>
//                     <p className="text-muted">You haven't made any payments yet</p>
//                 </div>
//             ) : (
//                 <div className="table-responsive">
//                     <Table striped bordered hover className="payment-history-table">
//                         <thead>
//                             <tr>
//                                 <th>Service</th>
//                                 <th>Date & Time</th>
//                                 <th>Amount</th>
//                                 <th>Details</th>
//                                 <th>Order ID</th>
//                                 <th>Status</th>
//                             </tr>
//                         </thead>
//                         <tbody>
//                             {payments.map((payment) => (
//                                 <tr key={payment._id}>
//                                     <td data-label="Service">
//                                         <strong>{payment.service || 'Unknown Service'}</strong>
//                                     </td>
//                                     <td data-label="Date & Time">{formatDate(payment.createdAt)}</td>
//                                     <td data-label="Amount">
//                                         {payment.currencySymbol || (payment.currency === 'INR' ? '₹' : '$')}
//                                         {payment.displayAmount || payment.amount.toFixed(2)}
//                                         {payment.gstApplied && (
//                                             <div className="text-muted small">(incl. GST)</div>
//                                         )}
//                                     </td>
//                                     <td data-label="Details">
//                                         {payment.location === 'india' ? 'India' : 'International'}
//                                         {payment.gstApplied && (
//                                             <div className="text-muted small">+18% GST</div>
//                                         )}
//                                     </td>
//                                     <td data-label="Order ID" className="text-monospace">
//                                         {payment.orderId}
//                                     </td>
//                                     <td data-label="Status">{getStatusBadge(payment.status)}</td>
//                                 </tr>
//                             ))}
//                         </tbody>
//                     </Table>
//                 </div>
//             )}
//         </div>
//     );
// };
// export default PaymentHistory;




import React, { useState, useEffect } from 'react';
import { Table, Spinner, Alert, Badge } from 'react-bootstrap';
import { FaFileInvoice, FaCheckCircle, FaTimesCircle, FaClock, FaRupeeSign, FaDollarSign } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import './PaymentHistory.css';

const PaymentHistory = () => {
    const [payments, setPayments] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        const fetchPayments = async () => {
            const token = localStorage.getItem('token');
            if (!token) {
                navigate('/login');
                return;
            }

            try {
                const userResponse = await fetch(`${process.env.REACT_APP_API_BASE_URL}/api/auth/user`, {
                    headers: { Authorization: `Bearer ${token}` },
                });

                if (!userResponse.ok) throw new Error('Failed to fetch user data');
                const userData = await userResponse.json();

                const paymentsResponse = await fetch(
                    `${process.env.REACT_APP_API_BASE_URL}/api/payment/user-payments/${userData.user._id}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                if (!paymentsResponse.ok) throw new Error('Failed to fetch payment history');
                const paymentsData = await paymentsResponse.json();

                setPayments(paymentsData);
            } catch (error) {
                setError(error.message);
            } finally {
                setLoading(false);
            }
        };

        fetchPayments();
    }, [navigate]);

    const formatDate = (dateString) => {
        const options = {
            year: 'numeric',
            month: 'short',
            day: 'numeric',
            hour: '2-digit',
            minute: '2-digit',
        };
        return new Date(dateString).toLocaleDateString(undefined, options);
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'completed':
                return (
                    <Badge bg="success" className="status-badge d-flex align-items-center">
                        <FaCheckCircle className="me-1" /> Completed
                    </Badge>
                );
            case 'failed':
                return (
                    <Badge bg="danger" className="status-badge d-flex align-items-center">
                        <FaTimesCircle className="me-1" /> Failed
                    </Badge>
                );
            default:
                return (
                    <Badge bg="warning" text="dark" className="status-badge d-flex align-items-center">
                        <FaClock className="me-1" /> Pending
                    </Badge>
                );
        }
    };

    const getCurrencyIcon = (currency) => {
        return currency === 'INR' ? <FaRupeeSign className="currency-icon" /> : <FaDollarSign className="currency-icon" />;
    };

    if (loading) {
        return (
            <div className="d-flex justify-content-center align-items-center py-5 min-vh-50">
                <Spinner animation="border" role="status" variant="primary">
                    <span className="visually-hidden">Loading...</span>
                </Spinner>
            </div>
        );
    }

    if (error) {
        return (
            <div className="payment-history-container">
                <Alert variant="danger" className="mt-4">
                    {error}
                </Alert>
            </div>
        );
    }

    return (
        <div className="payment-history-container">
            <div className="payment-history-header">
                <h2>
                    <FaFileInvoice className="me-2" /> Payment History
                </h2>
                <p className="text-muted">View all your past transactions and payments</p>
            </div>

            {payments.length === 0 ? (
                <div className="no-payments text-center py-5">
                    <FaFileInvoice size={48} className="text-muted mb-3" />
                    <h5>No payment history found</h5>
                    <p className="text-muted">You haven't made any payments yet</p>
                </div>
            ) : (
                <div className="table-responsive">
                    <Table striped bordered hover className="payment-history-table">
                        <thead>
                            <tr>
                                <th className="service-col">Service</th>
                                <th className="date-col">Date & Time</th>
                                <th className="amount-col">Amount</th>
                                <th className="details-col">Details</th>
                                <th className="order-col">Order ID</th>
                                <th className="status-col">Status</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments.map((payment) => (
                                <tr key={payment._id}>
                                    <td data-label="Service" className="service-col">
                                        <strong>{payment.service || 'Unknown Service'}</strong>
                                    </td>
                                    <td data-label="Date & Time" className="date-col">
                                        {formatDate(payment.createdAt)}
                                    </td>
                                    <td data-label="Amount" className="amount-col">
                                        <div className="d-flex align-items-center">
                                            {getCurrencyIcon(payment.currency || 'INR')}
                                            <span className="ms-1">
                                                {payment.displayAmount || payment.amount.toFixed(2)}
                                            </span>
                                        </div>
                                        {payment.gstApplied && (
                                            <div className="text-muted small">(incl. GST)</div>
                                        )}
                                    </td>
                                    <td data-label="Details" className="details-col">
                                        {payment.location === 'india' ? 'India' : 'International'}
                                        {payment.gstApplied && (
                                            <div className="text-muted small">+18% GST</div>
                                        )}
                                    </td>
                                    <td data-label="Order ID" className="order-col">
                                        <span className="order-id">{payment.orderId}</span>
                                    </td>
                                    <td data-label="Status" className="status-col">
                                        {getStatusBadge(payment.status)}
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </Table>
                </div>
            )}
        </div>
    );
};

export default PaymentHistory;